var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"add-icon",attrs:{"height":"100%","viewBox":"0 0 26 26"}},[_c('circle',{attrs:{"cx":"13","cy":"13","r":"13"}}),_c('path',{attrs:{"d":"M12.9703 18.4385L12.9703 6.79485","stroke":"white","stroke-width":"2"}}),_c('path',{attrs:{"d":"M18.7925 12.6166L7.14886 12.6166","stroke":"white","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }